export default class ViewModes {

    constructor(modes = []) {
        this.modes = modes
        this.defaultMode = null
        this.activeMode = null
    }

    getDefault() { return this.modes[0] }

    getActive() { return this.activeMode }

    getList() { return this.modes }


    setDefault(mode) {
        var slug = mode instanceof ViewMode ? mode.slug : mode
        this.defaultMode = this.modes.reduce((res, m) => {
            return m.slug === slug ? m : res
        }, this.default)
    }

    setActive(mode) {
        var slug = mode instanceof ViewMode ? mode.slug : mode
        this.activeMode = this.modes.reduce((res, m) => {
            return m.slug === slug ? m.turnOn() : m.turnOff()
        }, this.default)
    }

    addMode(data) {
        var m = new ViewMode(data)
        this.modes.push(m)
        if (data.isDefault || !this.defaultMode) {
            this.setDefault(m)
        }
        if (data.isActive || !this.activeMode) {
            this.setActive(m);
        }
        return m;
    }
}

export class ViewMode {
    constructor(data) {
        this.displayName = data.displayName // e.g. "List view"
        this.slug = data.slug || data.displayName.split(' ').join('-').toLowerCase()
        this.faIconSlug = data.faIconSlug // e.g. "fa-th-list"
        this.events = {
            on: typeof data.onModeOn !== 'undefined' ? [data.onModeOn] : [],
            off: typeof data.onModeOff !== 'undefined' ? [data.onModeOff] : [],
        }
        this.active = data.isActive || false
    }

    onModeOn(action) {
        if (typeof action === 'function') {
            this.events.on.push(action)
        }
    }

    onModeOff(action) {
        if (typeof action === 'function') {
            this.events.off.push(action)
        }
    }

    turnOn() {
        this.events.on.map(action => action(this))
        this.active = true
        return this
    }

    turnOff() {
        this.events.off.map(action => action(this))
        this.active = false
        return this
    }

    isActive() {return this.active }

    getFAIcon() {
        var i = document.createElement('i')
        i.className = 'fa ' + this.faIconSlug
        i.setAttribute('aria-hidden', 'true')
        return i
    }
}
